<template>
    <div>
        <div class="layout-right bg mb16">
            <Form :label-width="98">
                <Row :gutter="24">
                    <Col span="8">
                        <Form-item label="产品名称">
                            <Input v-model.trim="params.productName" clearable placeholder="请输入投保公司" @on-enter="search"></Input>
                        </Form-item>
                    </Col>
                    <Col span="8">
                        <Form-item label="单号">
                            <Input v-model.trim="params.applicationNo" clearable placeholder="请输入单号" @on-enter="search"></Input>
                        </Form-item>
                    </Col>
                    <Col span="8">
                        <Form-item label="更新时间">
                            <Date-picker format="yyyy-MM-dd" style="width:100%;" type="daterange" placeholder="选择日期" clearable @on-change="dateChange"></Date-picker>
                        </Form-item>
                    </Col>
                </Row>
                <Row>
                    <Col span="24" class="right">
                        <Button type="primary" @click="search">搜索</Button>
                    </Col>
                </Row>
            </Form>
        </div>
        <div class="layout-right bg">
            <i-table :columns="columns" url="/broker/insurance/application/pageList.json" :params="params" ref="table">
                <template slot-scope="{ row }" slot="action">
                    <Dropdown transfer>
                        <a href="javascript:void(0)">
                            管理
                            <Icon type="ios-arrow-down"></Icon>
                        </a>
                        <Dropdown-menu slot="list">
                            <Dropdown-item @click.native="toEdit(row)" style="text-align: center;">
                                <a>编辑</a>
                            </Dropdown-item>
                            <Dropdown-item @click.native="toDelete(row)" style="text-align: center;">
                                <a>删除</a>
                            </Dropdown-item>
                        </Dropdown-menu>
                    </Dropdown>
                </template>
            </i-table>
        </div>
    </div>
</template>
<script>
    import ITable from '../../../companyGroupEmployerDadi/common/ITable'
    import { mapState } from 'vuex'
    export default {
        components:{ ITable },
        name:'drafts',
        data () {
            return {
                params:{
                    bizId: "INDUSTRY_ENTERPRISE",
                    insuranceApplicationStatus:'UNCONFIRMED'
                },
                columns: [
                    {title:'单号',key:'applicationNo',width: 260,fixed: 'left'},
                    {title:'产品名称',key:'productName',ellipsis: true,tooltip: true},
                    {title:'更新时间',key:'updateTime'},
                    {
                        title: '操作',
                        slot: 'action',
                        width: 100,
                        align: 'center',
                        fixed: 'right'
                    }
                ]
            }
        },
        created(){
          
        },
        computed:{
            ...mapState({
                userInfo:state=>state.common.info,
                loginUserChannelUserType: state=>state.common.info.loginUserChannelUserType,
            })
        },
        watch:{
            
        },
        methods: {
            search(){
                this.$refs.table.getList()
            },
            // 时间选择
            dateChange(value) {
                if (value[0]) {
                    this.params.updateTimeBegin = value[0] + ' 00:00:00'
                    this.params.updateTimeEnd = value[1] + ' 23:59:59'
                } else {
                    this.params.updateTimeBegin = ''
                    this.params.updateTimeEnd = ''
                }
            },
            toEdit(row){
                this.$router.push({
                    path:`/companyGroupEmployerDadi/fillin/${row.applicationNo}?productCode=${row.productCode}&productName=${row.productName}&reset=NEW`
                })
            },
            toDelete(row){
                this.$axios.post('/broker/insurance/application/delete.json',{
                    applicationId: row.insuranceApplicationId
                }).then(res=>{
                    this.$Message.success('删除成功!');
                    this.search()
                })
            }
        }
    }
</script>
<style lang="less" scoped>
</style>



// WEBPACK FOOTER //
// src/pages/haierProduct/components/my/customizedDadi/drafts/index.vue